import "jquery-match-height";
import nextTick from "General/global-js/nextTick";
import('Foundation/Common/code/Scripts/Events/ResizeEndEvent');
import "Feature/SimpleLanguage/code/Styles/simplelanguageTileChildrenOverview.scss"

window.am = window.am || {};

window.am.simplelanguageTileChildrenOverview = new function () {
    const init = () => {
        let overview = document.querySelector('.nav-simple-language-tile-children-overview');
        
        window.addEventListener('resizeEnd', matchHeightText);
        window.addEventListener('resizeEnd', equalSquareHeightForImage);
        $(overview).find('img.lazyload').on('load', matchHeightText);
        $(overview).find('img.lazyload').on('load', equalSquareHeightForImage);

        equalSquareHeightForImage();
        nextTick(() => {
            matchHeightText();
        });
    };

    const matchHeightText = () => {
        const tiles = document.querySelectorAll('.nav-simple-language-tile-children-overview__text');
        let tallestText = 0;

        tiles.forEach((tile) => {
            tile.style.height = 'auto';

            if (tile.offsetHeight > tallestText) {
                tallestText = tile.offsetHeight;
            }
        });

        tiles.forEach((tile) => {
            tile.style.height = `${tallestText}px`;
        });
    };

    const equalSquareHeightForImage = () => {
        const images = document.querySelectorAll('.nav-simple-language-tile-children-overview__image img');

        images.forEach((image) => {
            image.style.height = `${image.offsetWidth}px`;
        });
    };

    return {
        init: init
    };
};

window.addEventListener('load', window.am.simplelanguageTileChildrenOverview.init);